module.exports = __webpack_public_path__ + "assets/img/perso1.0f32f025.png";